<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="12">
                <v-btn @click="doPingApi()" block append-icon="mdi-check-circle">Ping API</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import { pingApi } from "@/services/labview-api.service";
import { useAuth0 } from "@auth0/auth0-vue";
const { getAccessTokenSilently } = useAuth0();

const doPingApi = async () => {
    const accessToken = await getAccessTokenSilently();
    await pingApi(accessToken)
}
</script>
